import baseAPI from "../app/baseAPI";

export const ProductReducer = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    fetchProductDetails: builder.query({
      query: () => ({
        url: "https://jobmanagement-497524552274.us-central1.run.app/api/jobs/create",
        method: "GET",
      }),
      keepUnusedDataFor: 5,
    }),
    sendProductJobDetails: builder.mutation({
      query: (obj) => ({
        url: "https://jobmanagement-497524552274.us-central1.run.app/api/jobs/list",
        method: "POST",
        body: obj,
      }),
      keepUnusedDataFor: 5,
    }),
    updateCart: builder.mutation({
      query: ({ Id, paramsData }) => ({
        url: `https://jobmanagement-497524552274.us-central1.run.app/api/jobs${Id}`,
        method: "PATCH",
        body: paramsData,
      }),
      keepUnusedDataFor: 5,
    }),
    fetchCardDetails: builder.query({
      query: () => ({
        url: "https://jobmanagement-497524552274.us-central1.run.app/api/jobs/list",
        method: "GET",
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useFetchProductDetailsQuery,
  useFetchCardDetailsQuery,
  useUpdateCartMutation,
  useSendProductJobDetailsMutation,
} = ProductReducer;
